import { useAuthQuery } from './useAuthQuery';
import { supabase } from '@/integrations/supabase/client';
import { Project } from '@/types/project';

export const useProjectDetail = (projectId: string) => {
  return useAuthQuery<Project>({
    queryKey: ['project-detail', projectId],
    queryFn: async (): Promise<Project> => {
      const { data, error } = await supabase
        .from('projects')
        .select(`
          *,
          project_team_leads(
            user_id,
            profiles(
              id,
              full_name,
              email
            )
          )
        `)
        .eq('id', projectId)
        .single();

      if (error) {
        throw error;
      }

      return data;
    },
    requiresAuth: true,
    enabled: !!projectId,
    staleTime: 5 * 60 * 1000, // 5 minutes
    gcTime: 10 * 60 * 1000, // 10 minutes
    refetchOnWindowFocus: false,
    refetchOnReconnect: false,
  });
};